<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content *ngIf="!isLoading">
  <mat-card appearance="outlined">
    <mat-card-title>Infos: {{screen.productName}} - {{screen.remark}}</mat-card-title>

    <mat-card appearance="outlined">
      <table>
        <tr>
          <td>remark:</td>
          <td>{{screen.remark}}</td>
        </tr>
        <tr>
          <td>isTouch2015:</td>
          <td>
            <ng-container *ngIf="screen.isTouch2015"><i class="material-icons">check_box</i></ng-container>
            <ng-container *ngIf="!screen.isTouch2015"><i class="material-icons">indeterminate_check_box</i></ng-container>
          </td>
        </tr>
        <tr>
          <td>productName:</td>
          <td>{{screen.productName}}</td>
        </tr>
        <tr>
          <td>masterLanguage:</td>
          <td>{{screen.masterLanguage}}</td>
        </tr>
      </table>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined">
      <table>
        <tr>
          <td>screen _id:</td>
          <td>{{screen._id}}</td>
        </tr>
        <tr>
          <td>screen uuid:</td>
          <td>{{screen.uuid}}</td>
        </tr>
        <tr>
          <td>ibexCustomerId:</td>
          <td>{{screen.ibexCustomerId}}</td>
        </tr>
        <tr>
          <td>IbexId:</td>
          <td>{{screen.ibexId}}</td>
        </tr>
      </table>
    </mat-card>
  </mat-card>

  <div class="spacer"></div>

  <button (click)="generateCustomJsons()" *ngIf="cf" class="ibexfusion-raised-button" mat-button>Generate JSON's by cf</button>
  <data-table (detail)="navigateToJsonDetail($event)" (edit)="navigateToJsonEdit($event)" [columns]="jsonDataTableColumns"
                  [dataProviderParams]="jsonDataProviderParams" [dataProvider]="jsonService" [hideSearch]="true"
                  title="Custom JSONs"></data-table>

  <div class="spacer"></div>

  <mat-card appearance="outlined">
    <mat-card-title>Links</mat-card-title>

    <mat-card appearance="outlined">
      <mat-card-title>Preview Url:</mat-card-title>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/preview.html" target="_blank">{{urlBase}}/preview.html</a>
      <br/>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/preview.html#touch2go" target="_blank">{{urlBase}}/preview.html#touch2go</a>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined">
      <mat-card-title>Touch2015 Standard Url:</mat-card-title>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/screen.html" target="_blank">{{urlBase}}/screen.html</a>
    </mat-card>

    <div class="spacer"></div>

    <mat-card appearance="outlined">
      <mat-card-title>Touch2015 Mobile Url:</mat-card-title>
      <i class="material-icons">link</i>
      <a href="{{urlBase}}/app.html" target="_blank">{{urlBase}}/app.html</a>
    </mat-card>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined">
    <mat-card-title>Redirects</mat-card-title>
    <data-table (detail)="navigateToRedirect($event)"
                    *ngIf="redirects && redirects.length"
                    [columns]="redirectDataTableColumns"
                    [hideSearch]="true"
                    [plainData]="redirects"></data-table>
  </mat-card>


</page-content>
